import {useCallback} from 'react'
import {useGameStore} from '../GameStoreContext.ts'
import {GameTypeEnum} from '@colonist/game-base-types'
import {useShareReplay} from './useShareReplay.ts'

const GAME_TYPES_THAT_DO_NOT_SUPPORT_SHARING_GAME_RESULTS = [GameTypeEnum.BeginnerMode, GameTypeEnum.Tutorial, GameTypeEnum.BotGame]

export const useShareGameResults = () => {
    const gameType = useGameStore((state) => state.gameSettings.gameType)
    const canShareGameResults = !GAME_TYPES_THAT_DO_NOT_SUPPORT_SHARING_GAME_RESULTS.includes(gameType)

    let shareGameResults: VoidFunction | undefined

    if(canShareGameResults) {
        shareGameResults = useGameStore((state) => state.gameEnd.endControls?.onClickShareGameResults)
    } else {
        shareGameResults = useShareReplay()
    }

    return useCallback(() => {
        if(shareGameResults) shareGameResults()
    }, [shareGameResults])
}
